import { toast } from 'react-toastify';
import { convertPageableResponse } from '../../utils/responseMapper';
import * as api from '../api/brandsApi';
import * as types from '../constants/brandsConstants';

export const getBrandsActions = (search, unpaged) => async (dispatch) => {
  dispatch({ type: types.GET_BRANDS_REQUEST });
  try {
    const { error, data } = await api.getBrands(search, unpaged);
    if (error) {
      throw new Error(error);
    }

    const { content, ...paginationData } = data;
    const pageable = convertPageableResponse(paginationData);

    dispatch({
      type: types.GET_BRANDS_SUCCESS,
      payload: {
        data: content,
        pageable: pageable,
      },
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список марок автомобілів');
    dispatch({ type: types.GET_BRANDS_FAILURE });
  }
};

export const updateBrandAction = (brand) => async () => {
  try {
    const { error } = await api.updateBrand(brand);
    if (error) {
      throw new Error(error);
    }
    toast.success('Деталь була успішно змінена');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити марку');
  }
};

export const createBrandAction = (brand) => async () => {
  try {
    const { error } = await api.createBrand(brand);
    if (error) {
      throw new Error(error);
    }
    toast.success('Деталь була успішно додана');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося додати марку');
  }
};

export const deleteBrandAction = (brandId) => async () => {
  try {
    const { error } = await api.deleteBrand(brandId);
    if (error) {
      throw new Error(error);
    }
    toast.success('Деталь була успішно видалена');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося видалити марку');
  }
};

export const clearBrandsActions = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_BRANDS,
  });
};

export const setBrandsPageSizeAction = (pageSize) => async (dispatch) => {
  dispatch({
    type: types.SET_BRANDS_PAGE_SIZE,
    payload: pageSize,
  });
};

export const setSelectedBrandAction = (brand) => async (dispatch) => {
  dispatch({
    type: types.SELECT_BRAND,
    payload: brand,
  });
};

export const clearSelectedBrandAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_SELECTED_BRAND,
  });
};

export const setBrandsSearchAction = (search) => async (dispatch) => {
  dispatch({
    type: types.SET_BRANDS_SEARCH,
    payload: search,
  });
};

export const nextBrandsPageAction = () => async (dispatch) => {
  dispatch({
    type: types.NEXT_BRANDS_PAGE,
  });
};

export const prevBrandsPageAction = () => async (dispatch) => {
  dispatch({
    type: types.PREV_BRANDS_PAGE,
  });
};
